import BaseInfoView from './src/baseInfo.vue';

/* istanbul ignore next */
BaseInfoView.install = function(Vue) {
    Vue.component(BaseInfoView.name, BaseInfoView);
};

export default BaseInfoView;